/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetExamTypeDto } from './GetExamTypeDto';
import {
    GetExamTypeDtoFromJSON,
    GetExamTypeDtoFromJSONTyped,
    GetExamTypeDtoToJSON,
} from './GetExamTypeDto';

/**
 * 
 * @export
 * @interface GetExamTypeForChannelDto
 */
export interface GetExamTypeForChannelDto {
    /**
     * 
     * @type {string}
     * @memberof GetExamTypeForChannelDto
     */
    id: string;
    /**
     * 
     * @type {GetExamTypeDto}
     * @memberof GetExamTypeForChannelDto
     */
    examType: GetExamTypeDto;
}

/**
 * Check if a given object implements the GetExamTypeForChannelDto interface.
 */
export function instanceOfGetExamTypeForChannelDto(value: object): value is GetExamTypeForChannelDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('examType' in value) || value['examType'] === undefined) return false;
    return true;
}

export function GetExamTypeForChannelDtoFromJSON(json: any): GetExamTypeForChannelDto {
    return GetExamTypeForChannelDtoFromJSONTyped(json, false);
}

export function GetExamTypeForChannelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExamTypeForChannelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'examType': GetExamTypeDtoFromJSON(json['examType']),
    };
}

export function GetExamTypeForChannelDtoToJSON(value?: GetExamTypeForChannelDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'examType': GetExamTypeDtoToJSON(value['examType']),
    };
}

